import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Login from "./layouts/auth/login.layout";
import UserDashboard from "./layouts/user/dashboard.layout";
import Lcsc from "./layouts/user/lcsc.layout";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Navigate to="/login" replace />} />
        <Route exact path="/login" element={<Login />} />
        <Route
          exact
          path="/user"
          element={<Navigate to="/user/dashboard" replace />}
        />
        <Route exact path="/user/dashboard" element={<UserDashboard />} />
        <Route exact path="/user/lcsc" element={<Lcsc />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
